var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalculator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2C2C2C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.6,0H1.3C0.6,0,0,0.6,0,1.3v6.2c0,0.7,0.6,1.3,1.3,1.3h6.2c0.7,0,1.3-0.6,1.3-1.3V1.3C8.9,0.6,8.3,0,7.6,0z  M7.2,5H5v2.2H3.9V5H1.7V3.9h2.2V1.7H5v2.2h2.2C7.2,3.9,7.2,5,7.2,5z M18.7,0h-6.2c-0.7,0-1.3,0.6-1.3,1.3v6.2 c0,0.7,0.6,1.3,1.3,1.3h6.2c0.7,0,1.3-0.6,1.3-1.3V1.3C20,0.6,19.4,0,18.7,0z M18.3,5h-5.6V3.9h5.6V5z M7.6,11.1H1.3 c-0.7,0-1.3,0.6-1.3,1.3v6.2C0,19.4,0.6,20,1.3,20h6.2c0.7,0,1.3-0.6,1.3-1.3v-6.2C8.9,11.7,8.3,11.1,7.6,11.1z M6.8,17.1L6,17.9 l-1.6-1.6l-1.6,1.6l-0.8-0.8l1.6-1.6L2.1,14l0.8-0.8l1.6,1.6L6,13.2L6.8,14l-1.6,1.6L6.8,17.1L6.8,17.1z M18.7,11.1h-6.2 c-0.7,0-1.3,0.6-1.3,1.3v6.2c0,0.7,0.6,1.3,1.3,1.3h6.2c0.7,0,1.3-0.6,1.3-1.3v-6.2C20,11.7,19.4,11.1,18.7,11.1z M17.8,17.2h-4.4 v-1.1h4.4L17.8,17.2L17.8,17.2z M17.8,15h-4.4v-1.1h4.4L17.8,15L17.8,15z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.fea061a3.svg";
export { ForwardRef as ReactComponent };